var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssigned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95882 14.137C7.69965 13.3961 8.90274 13.3961 9.64357 14.137L10.1375 14.6308L12.0244 12.7439C12.3917 12.3703 12.8729 12.1867 13.3604 12.1867C13.3541 10.8507 12.6766 9.6286 11.5495 8.90675L10.9923 8.55216C9.9095 9.69825 8.37717 10.4201 6.68021 10.4201C4.98325 10.4201 3.45093 9.69825 2.36815 8.55216L1.81093 8.90675C0.677525 9.63494 0 10.8633 0 12.2057V15.8782C0 16.923 0.861138 17.7778 1.91223 17.7778H7.90862L6.95882 16.8217C6.21799 16.0809 6.21799 14.8778 6.95882 14.137Z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68029 9.15358C9.21865 9.15358 11.2764 7.1153 11.2764 4.60096C11.2764 2.08662 9.21865 0.0483398 6.68029 0.0483398C4.14194 0.0483398 2.08419 2.08662 2.08419 4.60096C2.08419 7.1153 4.14194 9.15358 6.68029 9.15358Z",
    fill: "#8E8E8E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8145 13.6423C13.5672 13.3949 13.1665 13.3949 12.9191 13.6423L10.1381 16.4233L8.74892 15.0339C8.50158 14.7865 8.10089 14.7865 7.85354 15.0339C7.6062 15.2809 7.6062 15.6819 7.85354 15.9293L9.69037 17.7664C9.80909 17.8851 9.97017 17.9519 10.1381 17.9519C10.3059 17.9519 10.467 17.8851 10.5857 17.7664L13.8145 14.5377C14.0618 14.2903 14.0618 13.8896 13.8145 13.6423Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssigned);
export default __webpack_public_path__ + "static/media/assigned.2a39bf7cc49a31261e58cc8f7e161ddc.svg";
export { ForwardRef as ReactComponent };